export default __webpack_public_path__ + "static/video-2-4b8992f2d8b713635a5c134a8ad88760.png";